import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { Tyre, TyreDiscount } from "models";

export type TyreDelivery = {
  id: string;
  order_before: string | null;
  delivery_before: string | null;
  delivery_from: string | null;
};

const component = "TyreGroup";

export const TyreGroupQueryKeys = {
  brands: permanentBackendQueryKey<string[]>({
    component,
    baseUrl: ENV.carBaseURL,
    endpoint: "/tyres/brands/list"
  }),
  claireTyreSearchResults: backendQueryKey<Tyre[]>({
    component,
    baseUrl: ENV.carBaseURL,
    endpoint: "/tyres/search"
  }),
  discounts: (dealer_id?: number) =>
    permanentBackendQueryKey<TyreDiscount[]>({
      component,
      baseUrl: ENV.dealerBaseURL,
      endpoint: "/tyre_discounts/list_discounts",
      params: { dealer_id }
    }),
  tyreNetSearchResults: backendQueryKey<Tyre[]>({
    component,
    baseUrl: ENV.tyreNetBaseURL,
    endpoint: "/catalog/search"
  }),
  tyreNetStock: (vehicle_tyre_replacement_ids: number[]) =>
    backendQueryKey<Tyre[]>({
      component,
      baseUrl: ENV.tyreNetBaseURLV2,
      endpoint: "/catalog/stock",
      params: { vehicle_tyre_replacement_ids }
    }),
  tyreTeamBrands: (dealer_location_id: number) =>
    permanentBackendQueryKey<string[]>({
      component,
      baseUrl: ENV.tyreTeamBaseURL,
      endpoint: "/catalog/brands/list",
      params: { dealer_location_id }
    }),
  tyreTeamDeliveries: (dealer_location_id?: number) =>
    permanentBackendQueryKey<TyreDelivery[]>({
      component,
      baseUrl: ENV.tyreTeamBaseURL,
      endpoint: "/catalog/delivery_types/list",
      params: { dealer_location_id }
    }),
  tyreTeamSearchResults: backendQueryKey<Tyre[]>({
    component,
    baseUrl: ENV.tyreTeamBaseURL,
    endpoint: "/catalog/search"
  }),
  tyreTeamStock: (vehicle_tyre_replacement_ids: number[]) =>
    backendQueryKey<Tyre[]>({
      component,
      baseUrl: ENV.tyreTeamBaseURLV2,
      endpoint: "/catalog/stock",
      params: { vehicle_tyre_replacement_ids }
    })
};
